require('../../../modules/es.string.fontcolor');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('String').fontcolor;
